import { ContactForm, useSendContactForm } from '@netfront/gelada-identity-library';
import { Breadcrumbs, IBreadcrumbItem } from '@netfront/ui-library';
import kebabCase from 'lodash.kebabcase';

import { Affiliates } from '../components/Affiliates';
import { BreadcrumbItemHomePageLink, BreadcrumbItem } from '../components/BreadcrumbItems';
import { BUTTON_CLASSES } from '../components/Button';
import { HelpButton } from '../components/HelpButton';
import { PageLayout } from '../components/PageLayout';
import { useToast } from '../hooks/useToast';
import { useRouter } from 'next/router';

const PAGE_TITLE = 'Contact';

const BREADCRUMB_ITEMS: IBreadcrumbItem[] = [
  {
    content: <BreadcrumbItemHomePageLink />,
    key: 'home',
  },
  {
    content: <BreadcrumbItem text={PAGE_TITLE} />,
    key: kebabCase(PAGE_TITLE),
  },
];

const ContactPage = () => {
  const { push } = useRouter();
  const { handleToastError } = useToast();

  const handleSendContactFormCompleted = () => {
    push('/contact-submitted');
  };

  const handleSendContactFormError = (error: Error) => {
    handleToastError({
      shouldUseFriendlyErrorMessage: true,
      error,
    });
  };

  const { handleSendContactForm } = useSendContactForm({
    onCompleted: handleSendContactFormCompleted,
    onError: handleSendContactFormError,
  });

  return (
    <PageLayout title={PAGE_TITLE}>
      <div className="container-md flex justify-end py-8">
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </div>

      <div className="container-md pb-8 pt-4">
        <div className="flex flex-col mb-4 md:flex-row">
          <div className="mb-4 md:mb-0 md:w-4/5 w-full">
            <h1 className="color-accent h4 mb-2 weight-800">Get in touch</h1>
            <h2 className="color-blue-900 h2">Contact the CarerWell team</h2>
            <hr className="bg-grey-100 block border-none h-0-5 ml-0 mt-7 radius-full w-third" role="presentation" />
          </div>

          <div className="align-center flex w-full">
            <div className="bg-grey-100 flex-1 h-0-5 md:flex mx-8 none radius-full" role="presentation" />
            <HelpButton />
          </div>
        </div>
      </div>

      <section className="pb-12 pt-4">
        <div className="container-md flex flex-col md:flex-row">
          <div className="mb-12 md:mb-0 md:mr-24 w-full">
            <ContactForm
              buttonClassName={`${BUTTON_CLASSES.default} mt-4`}
              isSubmitting={false}
              onSubmit={(email, message, name) => {
                handleSendContactForm({
                  firstName: name,
                  lastName: '',
                  message,
                  sender: email,
                });
              }}
            />
          </div>

          <div className="flex justify-center md:w-3/4 w-full">
            <img alt="Cartoon of user engaging with the CarerWell program" loading="lazy" src="/images/pre-chapter-illustration.svg" />
          </div>
        </div>
      </section>

      <Affiliates />
    </PageLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default ContactPage;
